import React from "react";
import SEO from "@/components/SEO";
import { useContent } from "@/context/ContentContext";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  const { c } = useContent();

  return (
    <>
      <SEO title="Contact" path="/contact" description="Contact VoiceOverKids — international child voice casting agency & recording studio in Leiden, The Netherlands." />
      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Contact</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Get in touch</h1>
        </div>
      </section>

      <section className="container-x section-y grid gap-12 lg:grid-cols-[1fr_1.3fr]">
        <div>
          <h2 className="font-heading text-xl font-bold">Contact information</h2>
          <div className="mt-5 space-y-4 text-zinc-700">
            <a href={`mailto:${c("contact_email", "bookings@voiceoverkids.agency")}`} className="flex items-center gap-3 hover:text-brand-violet"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><Mail size={18} /></span> {c("contact_email", "bookings@voiceoverkids.agency")}</a>
            <a href={`tel:${c("contact_phone", "+31 71 2032441").replace(/\s/g, "")}`} className="flex items-center gap-3 hover:text-brand-violet"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><Phone size={18} /></span> {c("contact_phone", "+31 71 2032441")}</a>
            <div className="flex items-start gap-3"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><MapPin size={18} /></span>
              <span className="whitespace-pre-line">{c("contact_address", "VoiceOverKids.Agency\nDe Savornin Lohmanplein 2\n2314 EV Leiden, The Netherlands")}<br /><span className="text-sm text-zinc-500">KVK 53824784 · VAT NL001977309B09</span></span>
            </div>
          </div>
          <div className="mt-8 rounded-2xl border border-zinc-200 bg-white p-5">
            <p className="text-sm text-zinc-600">Ready to cast? Skip the form and send us a full brief.</p>
            <Link to="/casting" className="mt-3 inline-flex items-center gap-2 font-bold text-brand-violet">Start a casting <ArrowRight size={16} /></Link>
          </div>
        </div>

        <div>
          <h2 className="font-heading text-xl font-bold">General enquiry</h2>
          <iframe
            title="Contact form"
            src="https://eu.forms.app/blue1media/contact-form-1"
            data-testid="contact-form-iframe"
            loading="lazy"
            allow="clipboard-write; fullscreen"
            style={{ width: "100%", border: 0, minHeight: 1200 }}
            className="mt-5 block"
          />
        </div>
      </section>
    </>
  );
}
